import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content-grid content-grid--subpage content-grid--subpage-table" }
const _hoisted_2 = { class: "content-grid__header" }
const _hoisted_3 = { class: "back-link-title" }
const _hoisted_4 = { class: "content-grid__filters" }

import i18n from "@/i18n";
import {useI18n} from "vue3-i18n";
import {computed, onMounted, ref} from "vue";
import {useBookService} from "@/inversify.config";
import {notifyError, notifySuccess} from "@/notify";
import Card from "@/components/layout/Card.vue";
import Breadcrumbs from "@/components/layout/Breadcrumbs.vue";
import SearchInput from "@/components/layout/SearchInput.vue";
import DataTable from "@/components/layout/DataTable.vue";
import BtnLink from "@/components/layout/BtnLink.vue";
import {Book} from "@/types/entities";
import {Guid} from "@/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'AdminBookIndex',
  setup(__props) {

const {t} = useI18n()
const bookService = useBookService()

const allBooks = ref<Book[]>([]);
const searchValue = ref("");
const booksAreLoading = ref(false);

const tableBooks = computed(() => {
  let lang = i18n.getLocale()
  return allBooks.value.map((x: Book) => {
    return {
      id: x.id,
      name: (lang == 'fr' ? x.nameFr : x.nameEn) ?? '',
      isbn: x.isbn,
      author: x.author,
      editor: x.editor,
      actions: {
        update: {name: `admin.children.books.edit`, params: {id: x.id}},
        delete: true
      }
    }
  }).sort((a: any, b: any) => {
    if (a.name < b.name) {
      return -1;
    }
    if (a.name > b.name) {
      return 1;
    }
    return 0;
  }) as Book[];
})

onMounted(async () => {
  await loadAllBooks();
});

async function loadAllBooks() {
  booksAreLoading.value = true;

  let books = await bookService.getAllBooks();
  if (books && books.length > 0) {
    allBooks.value = books;
  }
  booksAreLoading.value = false;
}

async function deleteBook(book: any) {
  if (book?.id == null || !Guid.isValid(book.id ?? ""))
    return

  let confirmDelete = confirm(t("validation.book.delete.confirmation"));
  if (!confirmDelete)
    return;

  let response = await bookService.deleteBook(book.id)
  if (response.succeeded) {
    allBooks.value = allBooks.value.filter(x => x.id !== book.id)
    notifySuccess(t('validation.book.delete.success'))
  } else {
    let errorMessages = response.getErrorMessages('validation.book.delete',
        'validation.book.delete.errorOccured')
    notifyError(errorMessages[0])
  }
}

const bookHeader = [
  {
    text: t("book.title"),
    value: 'name',
    sortable: true,
    width: 300,
  },
  {
    text: t("book.isbn"),
    value: "isbn",
    sortable: true,
    width: 150,
  },
  {
    text: t("book.author"),
    value: "author",
    sortable: true,
    width: 125,
  },
  {
    text: t("book.editor"),
    value: "editor",
    sortable: true,
    width: 125,
  },
  {
    text: t("global.table.actions"),
    value: "actions",
    width: 75
  },
];


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Breadcrumbs, {
      title: _unref(t)(`routes.admin.children.books.name`)
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(t)(`routes.admin.children.books.name`)), 1),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(SearchInput, {
          modelValue: searchValue.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchValue).value = $event))
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createVNode(Card, {
      title: _unref(t)('global.quickLinks'),
      class: "card--row-content"
    }, {
      default: _withCtx(() => [
        _createVNode(BtnLink, {
          name: _unref(t)('routes.admin.children.books.add.name'),
          path: { name: 'admin.children.books.add' }
        }, null, 8, ["name", "path"])
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(Card, null, {
      default: _withCtx(() => [
        _createVNode(DataTable, {
          headers: bookHeader,
          "is-loading": booksAreLoading.value,
          items: tableBooks.value,
          "search-value": searchValue.value,
          onDelete: deleteBook
        }, null, 8, ["is-loading", "items", "search-value"])
      ]),
      _: 1
    })
  ]))
}
}

})